// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"d501973f","78":"ff41577a","198":"5b44bba8","747":"267d5019","974":"c7d4d8f9"}[chunkId] + ".chunk.js";
};